<div class="d-flex">
    <div class="d-flex flex-row-reverse align-items-center">
        <input ngbDatepicker #dp="ngbDatepicker" class="form-control input-date-picker" name="dp"
            [placeholder]="placeholder" [disabled]="disabled" [required]="required" [markDisabled]="isDisabledDate"
            [minDate]="minDate" [maxDate]="maxDate" [(ngModel)]="date" (ngModelChange)="emitChanges()"
            (blur)="onBlur()">
        <button *ngIf="date && !disabled" type="button" class="clear-btn" (click)="clearInput()" aria-label="Limpiar"
            container="body" data-toggle="tooltip" placement="top" [ngbTooltip]="clearText">
            &times;
        </button>
    </div>
    <div class="input-group-append input-date-picker-calendar">
        <div class="input-group-text" (click)="!disabled && dp.toggle()">
            <i class="fa fa-calendar" [style]="!disabled ? 'cursor: pointer;' : ''"></i>
        </div>
    </div>
</div>